import { useState } from 'react';
import UI from '../ui';
import { ISOToCountry } from '../functions/isoToCountry';
import { useNavigate } from 'react-router';
import PickIcon from './PickIcon';
import { post } from '../mocks/postsMocks/postsStore';
import PostImage from './PostImage';

const Reviews: React.FC<{ reviews: post['reviews'] }> = ({ reviews }) => {
  return (
    <UI.VerticalLayout gap={5}>
      {reviews.map((review, i) => {
        const { feature, description } = review;
        return (
          <UI.VerticalLayout key={i}>
            <UI.Text weight="bold" size="subtitle">{feature}</UI.Text>
            <UI.Text>{description}</UI.Text>
          </UI.VerticalLayout>
        );
      })}
    </UI.VerticalLayout>
  );
};

const Comments: React.FC<{ comments: post['comments'] }> = ({ comments }) => {
  return (
    <UI.VerticalLayout gap={5}>
      {comments.map((comment, i) => (
        <UI.Text key={i}>
          <UI.TextLink color="black" path={`/profile/${comment.user_id}`}>
            {comment.name}
            &nbsp;
          </UI.TextLink>
          <UI.Text>{comment.message}</UI.Text>
        </UI.Text>
      ))}
    </UI.VerticalLayout>
  );
};

const Post: React.FC<{ post: post, page?: boolean }> = ({ post, page }) => {
  const navigate = useNavigate();
  const [liked, setLiked] = useState(false);
  const [mode, setMode] = useState<'comments' | 'reviews'>('comments');
  const comments = page ? post.comments : [post.comments[0]];
  const reviews = post.reviews;
  return (
    <UI.VerticalLayout gap={5} overflow={page ? 'scroll' : undefined}>
      <UI.HorizontalLayout justify="space-between">
        <UI.VerticalLayout>
          <UI.TextLink color="black" path={`/profile/${post.user_id}`}>{post.user_name}</UI.TextLink>
          <UI.HorizontalLayout gap={5} align="center">
            {post.pick && <PickIcon animate={page} post={post} />}
            <UI.Text>{`${post.hotelName}, ${post.location.city}, ${ISOToCountry(post.location.country_code)}`}</UI.Text>
          </UI.HorizontalLayout>
        </UI.VerticalLayout>
        {page
          ? (
              <UI.Button
                label="Book"
                onClick={() => window.open(post.hotelUrl, '_blank')?.focus()}
              />
            )
          : (
              <UI.Button
                label="View"
                onClick={() => navigate(`/posts/${post.id}`)}
              />
            )}
      </UI.HorizontalLayout>
      <PostImage post={post} />

      <UI.HorizontalLayout gap={15}>
        <UI.IconButton name="favorite" onClick={() => setLiked(prev => !prev)} color={liked ? 'red' : undefined} />
        <UI.IconButton name="mode_comment" onClick={() => {}} />
        <UI.IconButton name="send" onClick={() => {}} />
      </UI.HorizontalLayout>

      <UI.Text>
        <UI.TextLink color="black" path={`/profile/${post.user_id}`}>
          {post.user_name}
          &nbsp;
        </UI.TextLink>
        <UI.Text>{post.description}</UI.Text>
      </UI.Text>

      {!page && (
        <UI.TextLink path={`/posts/${post.id}`}>
          View all comments
        </UI.TextLink>
      )}

      {page && (
        <UI.Tabs
          options={[
            { label: `comments (${comments.length})`, value: 'comments' },
            { label: `reviews (${reviews.length})`, value: 'reviews' },
          ]}
          value={mode}
          onChange={setMode}
          fullTabWidths
        />
      )}
      {{ comments: <Comments comments={comments} />, reviews: <Reviews reviews={reviews} /> }[mode]}

    </UI.VerticalLayout>
  );
};

export default Post;
